import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../statics/img/overage.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-c263c66c")

_pushScopeId("data-v-c263c66c")
const _hoisted_1 = { class: "statistics" }
const _hoisted_2 = { class: "module-row" }
const _hoisted_3 = { class: "module config" }
const _hoisted_4 = { class: "config-item" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 地址补充提示 ")
const _hoisted_6 = { class: "config-item" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "config-item-title" }, "展示国家", -1)
const _hoisted_8 = { class: "country-wrap" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 设置国家 ")
const _hoisted_10 = { style: {"max-width":"715px","line-height":"1.5"} }
const _hoisted_11 = { class: "selected-country" }
const _hoisted_12 = { class: "module overage" }
const _hoisted_13 = { class: "overage-head" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "overage-tit" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(" 余额 ")
], -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode("消耗明细")
const _hoisted_16 = { class: "overage-main" }
const _hoisted_17 = { class: "overage-val" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("充值")
const _hoisted_19 = { class: "module-row" }
const _hoisted_20 = { class: "module proportion" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "title" }, "国家比例", -1)
const _hoisted_22 = { class: "module chart" }
const _hoisted_23 = { class: "charts-wrap" }
const _hoisted_24 = { class: "charts-total" }
const _hoisted_25 = { class: "module-row" }
const _hoisted_26 = { class: "module logs" }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "title" }, "补全记录", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CountryModal = _resolveComponent("CountryModal")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_Tooltips = _resolveComponent("Tooltips")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_FillInput = _resolveComponent("FillInput")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_FormSkeleton = _resolveComponent("FormSkeleton")
  const _component_router_link = _resolveComponent("router-link")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_Table = _resolveComponent("Table")
  const _component_Charts = _resolveComponent("Charts")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_CountryModal, {
      modelValue: _ctx.visible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.visible = $event)),
      onConfirm: _ctx.changeCountries,
      checked: _ctx.config.countries,
      loading: _ctx.saveLoading
    }, null, 8, ["modelValue", "onConfirm", "checked", "loading"]),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_el_date_picker, {
        modelValue: _ctx.dateSection,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dateSection = $event)),
        type: "daterange",
        "start-placeholder": "",
        "end-placeholder": "",
        size: "large",
        clearable: false,
        style: {"margin-bottom":"16px"},
        onChange: _ctx.changeDate
      }, null, 8, ["modelValue", "onChange"]),
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_FormSkeleton, {
            loading: _ctx.configLoading,
            type: "form"
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_4, [
                _createVNode(_component_el_checkbox, {
                  size: "large",
                  modelValue: _ctx.config.notice,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.config.notice = $event)),
                  "true-label": 1,
                  "false-label": 0,
                  class: "config-item-title",
                  onChange: _ctx.save
                }, {
                  default: _withId(() => [
                    _createVNode(_component_Tooltips, {
                      content: "勾选地址补充提示，将在商城地址栏显示文本内容",
                      placement: "right"
                    }, {
                      default: _withId(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"]),
                _createVNode(_component_FillInput, {
                  "fill-text": _ctx.getDefault().notice_msg,
                  modelValue: _ctx.config.notice_msg,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.config.notice_msg = $event)),
                  onChange: _ctx.save
                }, null, 8, ["fill-text", "modelValue", "onChange"])
              ]),
              _createVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode("div", _hoisted_8, [
                  _createVNode(_component_el_button, {
                    size: "large",
                    type: "primary",
                    style: {"margin-right":"8px","min-width":"120px"},
                    onClick: _ctx.openCountryModal
                  }, {
                    default: _withId(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_el_tooltip, {
                    class: "box-item",
                    effect: "dark",
                    placement: "bottom"
                  }, {
                    content: _withId(() => [
                      _createVNode("div", _hoisted_10, _toDisplayString(_ctx.config.countries.join(', ')), 1)
                    ]),
                    default: _withId(() => [
                      _createVNode("div", _hoisted_11, "(" + _toDisplayString(_ctx.config.countries.join(', ')) + ")", 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _withDirectives(_createVNode("div", _hoisted_12, [
          _createVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_router_link, {
              class: "link",
              to: _ctx.getRoute('statistics/consume')
            }, {
              default: _withId(() => [
                _hoisted_15
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createVNode("div", _hoisted_16, [
            _createVNode("div", _hoisted_17, _toDisplayString(_ctx.overage), 1),
            _createVNode(_component_router_link, {
              class: "link",
              to: _ctx.getRoute('statistics/recharge')
            }, {
              default: _withId(() => [
                _createVNode(_component_el_button, {
                  size: "large",
                  type: "primary",
                  style: {"min-width":"120px"}
                }, {
                  default: _withId(() => [
                    _hoisted_18
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ], 512), [
          [_directive_loading, _ctx.overageLoading]
        ])
      ]),
      _createVNode("div", _hoisted_19, [
        _createVNode("div", _hoisted_20, [
          _hoisted_21,
          _createVNode(_component_Table, {
            data: _ctx.proportion,
            loading: _ctx.proportionLoading,
            ref: "mTable"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_table_column, {
                prop: "country",
                label: "国家"
              }),
              _createVNode(_component_el_table_column, {
                prop: "num",
                label: "搜索次数"
              }),
              _createVNode(_component_el_table_column, {
                prop: "num",
                label: "搜索占比"
              }, {
                default: _withId((scope) => [
                  _createTextVNode(_toDisplayString(((scope.row.num / _ctx.searchTotal) * 100).toFixed() + '%'), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data", "loading"])
        ]),
        _withDirectives(_createVNode("div", _hoisted_22, [
          _createVNode("div", _hoisted_23, [
            (_ctx.chartsSource && _ctx.proportion.length)
              ? (_openBlock(), _createBlock(_component_Charts, {
                  key: 0,
                  x: _ctx.chartsData.xAxis,
                  tooltipFormatter: _ctx.tooltipFormatter,
                  source: _ctx.chartsSource,
                  legend: { width: '180', itemGap: 16 },
                  grid: { top: 100 },
                  onlyInteger: ""
                }, null, 8, ["x", "tooltipFormatter", "source"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_24, [
            _createVNode("span", null, _toDisplayString(`${_ctx.chartsData.xAxis[0]} ~ ${_ctx.chartsData.xAxis[_ctx.chartsData.xAxis.length - 1]} 总数:`), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.chartsData.yAxis.length
              ? _ctx.chartsData.yAxis.reduce((total, item) => total + Number(item))
              : 0) + "次 ", 1)
          ])
        ], 512), [
          [_directive_loading, _ctx.chartsLoading]
        ])
      ]),
      _createVNode("div", _hoisted_25, [
        _createVNode("div", _hoisted_26, [
          _hoisted_27,
          _createVNode(_component_Table, {
            data: _ctx.logs,
            loading: _ctx.logLoading,
            ref: "mTable",
            pagination: _ctx.pagination,
            onCurrentChange: _ctx.pageChange
          }, {
            default: _withId(() => [
              _createVNode(_component_el_table_column, {
                prop: "place_id",
                label: "ID"
              }),
              _createVNode(_component_el_table_column, { label: "国家" }, {
                default: _withId((scope) => [
                  _createTextVNode(_toDisplayString(scope.row.country.chinese_name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "place",
                label: "地址"
              }),
              _createVNode(_component_el_table_column, { label: "创建时间" }, {
                default: _withId(({ row }) => [
                  _createTextVNode(_toDisplayString(row.create_at), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data", "loading", "pagination", "onCurrentChange"])
        ])
      ])
    ])
  ], 64))
})